import { KRP_BUSINESS } from "../../../mocks/krp-data";
import { useScrollRevealChildren } from "../../../hooks/useScrollReveal";

export default function TrustBar() {
  const ref = useScrollRevealChildren();

  const stats = [
    { number: "4.9", suffix: "★", label: "Star Rating", sub: "150+ Verified Reviews" },
    { number: "500+", suffix: "", label: "Projects Completed", sub: "Across South Florida" },
    { number: "$9,995", suffix: "", label: "Starting Investment", sub: "Designed & Installed" },
    { number: "15+", suffix: "", label: "Years of Excellence", sub: "Family-Owned & Operated" },
  ];

  const brands = ["Fabuwood", "Design·Craft", "Stonemark", "Julius Blum"];

  return (
    <section className="bg-[#F5F0E8] overflow-hidden">
      {/* Top thin gold line */}
      <div className="h-[2px] bg-gradient-to-r from-transparent via-[#C9A961]/30 to-transparent" />

      {/* Stats — editorial magazine style */}
      <div ref={ref} className="max-w-screen-xl mx-auto px-6 xl:px-10 pt-16 pb-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-0">
          {stats.map((stat, idx) => (
            <div
              key={stat.label}
              className={`reveal delay-${idx * 100 + 100} flex flex-col items-center text-center group ${
                idx < 3 ? "lg:border-r lg:border-[#DDD8CF]" : ""
              } px-4 lg:px-10`}
            >
              <div
                className="text-[60px] xl:text-[72px] leading-none text-[#1C1C1C] font-bold tracking-tight mb-2"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {stat.number}
                <span className="text-[#C9A961] text-3xl ml-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  {stat.suffix}
                </span>
              </div>
              <div
                className="text-[10px] tracking-[0.2em] uppercase text-[#444] font-semibold mb-1"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {stat.label}
              </div>
              <div
                className="text-[11px] text-[#AAA] font-light"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {stat.sub}
              </div>
              {/* Hover gold underline */}
              <div className="mt-3 h-[1px] w-8 bg-[#C9A961]/30 group-hover:w-16 group-hover:bg-[#C9A961] transition-all duration-500" />
            </div>
          ))}
        </div>
      </div>

      {/* Bottom brand strip */}
      <div className="border-t border-[#E5E0D7]">
        <div className="max-w-screen-xl mx-auto px-6 xl:px-10 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-5">
            <div className="flex items-center gap-3">
              <div className="h-px w-8 bg-[#C9A961]/40" />
              <span
                className="text-[#C4B99A] text-[9px] tracking-[0.3em] uppercase whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Trusted Partners
              </span>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-8 lg:gap-14">
              {brands.map((brand) => (
                <span
                  key={brand}
                  className="text-[#C4B99A] text-[11px] font-semibold tracking-[0.18em] uppercase hover:text-[#C9A961] transition-colors duration-300"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {brand}
                </span>
              ))}
            </div>
            <a
              href="tel:5614416008"
              className="flex items-center gap-2.5 whitespace-nowrap cursor-pointer group"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-[#C9A961]/10 group-hover:bg-[#C9A961] transition-colors duration-300">
                <i className="ri-phone-fill text-[#C9A961] group-hover:text-white text-sm transition-colors duration-300" />
              </div>
              <span
                className="text-[#1C1C1C] text-sm font-semibold group-hover:text-[#C9A961] transition-colors"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {KRP_BUSINESS.phone}
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
